import Services from './base-services'

const service = new Services('achievementEvents')

export default {
  getCurrentWeekEventsByUserId: (userId: any) => {
    return service.get(`getCurrentWeekEventsByUserId?bookUserId=${userId}`)
  },
  collectReward: (payload: any) => {
    return service.post(`collectReward?eventId=${payload.eventId}&userId=${payload.userId}`, payload)
  },
}
